/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MemberAccessControl } from '../../auth/access-control';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../services/api.service';
import { StorageService } from '../../../services/storage.service';
import { ReportsService } from '../../reports/reports.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { GroupsService } from '../../groups/groups.service';
import { MembersService } from '../members.service';
import _ from 'lodash';
import { LOCALIZATION, USER_ID, cropperConfig, USER_DP, USER_SUPER } from '../../../data-models/user-data';
import { ErrorHelpersService } from '../../../helpers/error-helpers.service';
import { SharedModule } from '../../shared/shared.moudle';
import { LoaderService } from '../../../services/loader.service';
import { COUNTRY_CODES } from '../../../data-models/country-codes';
import { map, Observable, startWith } from 'rxjs';
import { CdnFilePreviewComponent } from './components/cdn-file-preview/cdn-file-preview.component';
import { environment } from '../../../../environments/environments';
import { UploadService } from '../../../services/upload.service';
import { DateTimePipe } from '../../../helpers/date-time.pipe';
import { Clipboard } from '@angular/cdk/clipboard';
import { STATUS_ACTIVE, STATUS_PENDING_CONSENT, STATUS_PENDING_PASSWORD } from '../../../data-models/user-login';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DashboardService } from '../../dashboard/dashboard.service';
import { Actions, Subjects } from '../../../services/authentication.service';
import { NoAccessComponent } from "../../no-access/no-access.component";
import { PureAbility } from '@casl/ability';
import { ProfileMessagingService } from '../shared/profile-messaging.service';
import { isPhoneCodePairValid } from '../../../shared/forms/validators/form-validators';

const storage_user = environment.storage_user
const container_user = environment.container_user

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [SharedModule, CdnFilePreviewComponent, NoAccessComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {

  @ViewChild('myfileid2') myButton!: ElementRef<HTMLButtonElement>;
  imageChangedEvent: Event | null = null;
  croppedImage: any;

  API_URL = `${environment.apiURL}`

  private dateTimePipe: DateTimePipe;
  memberAccessControl = MemberAccessControl;

  addEducation!: FormGroup;
  preferedFoods!: FormGroup;
  addAchievments!: FormGroup;
  editContact!: FormGroup;
  editProfile!: FormGroup;
  visible: boolean| any = false
  contact: boolean| any = false
  preference: boolean| any = false
  educationalQ: boolean | any= false
  licensesEdit: boolean | any= false
  // carrier:boolean = false
  achievment: boolean| any = false
  date: Date = new Date();
  username: any = ""; usernameValid: boolean| any = true;
  gender: any = ""; genderValid: boolean| any = true;
  fname: any = ""; fnameValid: boolean| any = true;
  mname: any = "";
  lname: any = ""; lnameValid: boolean | any= true;
  dateValid: boolean | any = true;

  id: any
  userid: any
  user: any = {}
  achievement: any = {}
  homework: any = {}
  members: any = []
  coachs: any = []
  sports: any = []
  ach_limit: number | any = 2
  a_g_limit: number | any = 3
  a_c_limit: number | any = 3
  a_s_limit: number | any = 3
  datePickersettings = {
    bigBanner: true,
    timePicker: false,
    format: 'dd-MM-yyyy',
    defaultOpen: false
  }

  personal_dev_hours: any = 0
  personal_dev_current: any = 0
  personal_dev_total: any = 0

  attendance_dev_percentage: any = 0
  attendance_dev_current: any = 0
  attendance_dev_total: any = 0

  homework_completed: any = []
  homework_pending: any = []

  user_feed_all: any = []
  user_feed: any = []
  user_feed_loading = true;
  vaildDate: boolean | any = true
  addressEmpty: boolean | any = true;

  attendenceDetails: any;

  academicStatsLoading = true;
  academicStats: any;
  selectedYear = new Date();
  selectedTerm: string | any = "";

  targetAchievedCountForGrades = 0;
  totalSubjectsCount = 0;
  pdStats: any;
  pdStatSessions: any;
  OverSession: any = [];
  OverSessionAll: any = [];
  _id: string | any;
  class_id: string | any = null;
  dev_hours: any = 0;

  is_loading_achievments: boolean | any = true;
  is_loading_preferences: boolean | any = true;
  is_loading_sports_info: boolean | any = true;
  is_loading_educational: boolean | any = true;
  // is_loading_contacts: boolean = true;
  is_loading_bio: boolean | any = true;

  prefered_position: any;
  educational: any = []
  education: any = []
  licenses: any = []

  submitted: boolean | any = false
  dobEdit: boolean | any = true
  parent_edit: boolean | any = false
  parent_edit2: boolean | any = false
  contact_edit: boolean | any = false
  classes: any = []
  class_name: any = "Select a class"
  overall_info: any = {}

  maxYear: Date = new Date();

  @ViewChild('picker', { static: false })
  private picker!: MatDatepicker<Date>;
  profile_report: any = {};
  phone: any = {
    country_code: "",
    number: "",
    is_primary: true,
  };
  characteristics_edit: boolean | any = false;
  createClick: boolean | any = false;

  originalContactDetails: any = {};
  phoneCode: any = COUNTRY_CODES
  filteredOptionsPhoneCodes:  Observable<any[]> | undefined;
  phoneCodeControl = new FormControl('');
  locale_data: any
  active_status: any
  file: File | any;
  mode: string = 'consent'
  existingUser: boolean = false;
  isValid: boolean = true;
  already_a_academy_member: any;
  age: any = ''
  parent_copy_body: any = ""
  role: any;
  user_join: any = []

  editingJoinDate = false;
  tempJoinDate: any;


  tempParent1: any = {};
  tempParent2: any = {};

  phoneCodeControl1 = new FormControl('');
  filteredPhoneCodes1!: Observable<any[]>;

  parentPhoneCode1: string = '';
  parentPhoneNumber1: string = "";

  phoneCodeControl2 = new FormControl('');
  filteredPhoneCodes2!: Observable<any[]>;

  parentPhoneCode2: string = '';
  parentPhoneNumber2: string = "";


  unisexSizes = [
    { code: 'XXS', uk: '32', us: '32' },
    { code: 'XS',  uk: '34', us: '34' },
    { code: 'S',   uk: '36', us: '36' },
    { code: 'M',   uk: '38', us: '38' },
    { code: 'L',   uk: '40', us: '40' },
    { code: 'XL',  uk: '42', us: '42' },
    { code: 'XXL', uk: '44', us: '44' },
    { code: '3XL', uk: '46', us: '46' },
    { code: '4XL', uk: '48', us: '48' }
  ];

  womenSizes = [
    { code: 'XXS', uk: '4',  us: '0'   },
    { code: 'XS',  uk: '6',  us: '2-4' },
    { code: 'S',   uk: '8',  us: '4-6' },
    { code: 'M',   uk: '10', us: '8-10' },
    { code: 'L',   uk: '12', us: '12-14' },
    { code: 'XL',  uk: '14', us: '16-18' },
    { code: 'XXL', uk: '16', us: '18-20' },
    { code: '3XL', uk: '18', us: '20-22' }
  ];


  unisexShortsSizes = [
    { code: 'XS',  uk: '26-28', us: '26-28' },
    { code: 'S',   uk: '28-30', us: '28-30' },
    { code: 'M',   uk: '32-34', us: '32-34' },
    { code: 'L',   uk: '36-38', us: '36-38' },
    { code: 'XL',  uk: '40-42', us: '40-42' },
    { code: 'XXL', uk: '44-46', us: '44-46' },
    { code: '3XL', uk: '48-50', us: '48-50' },
    { code: '4XL', uk: '52-54', us: '52-54' }
  ];

  womenShortsSizes = [
    { code: 'XXS', uk: '4-6',   us: '0-2'   },
    { code: 'XS',  uk: '6-8',   us: '2-4'   },
    { code: 'S',   uk: '8-10',  us: '4-6'   },
    { code: 'M',   uk: '10-12', us: '6-8'   },
    { code: 'L',   uk: '12-14', us: '8-10'  },
    { code: 'XL',  uk: '14-16', us: '10-12' },
    { code: 'XXL', uk: '16-18', us: '12-14' },
    { code: '3XL', uk: '18-20', us: '14-16' }
  ];


  mensShoeSizes = [
    { uk: 5,  us: 6 },
    { uk: 6,  us: 7 },
    { uk: 7,  us: 8 },
    { uk: 8,  us: 9 },
    { uk: 9,  us: 10 },
    { uk: 10, us: 11 },
    { uk: 11, us: 12 },
    { uk: 12, us: 13 },
    { uk: 13, us: 14 },
    { uk: 14, us: 15 }
  ];

  womensShoeSizes = [
    { uk: 2,  us: 4 },
    { uk: 3,  us: 5 },
    { uk: 4,  us: 6 },
    { uk: 5,  us: 7 },
    { uk: 6,  us: 8 },
    { uk: 7,  us: 9 },
    { uk: 8,  us: 10 },
    { uk: 9,  us: 11 },
    { uk: 10, us: 12 }
  ];

  upload_image_type = 'dp';
  fileSelect = false;
  coverImageChangedEvent: any;
  profileImageChangedEvent: any;
  file2: any;
  upload: string | undefined;
  afterCrop = false;
  uploadPath: any;
  full_name: any = "";
  Action = Actions
  Subject = Subjects
  profile: any = []
  isProfileLoaded = false;




  constructor(
    private reportsapiService: ReportsService,
    public datepipe: DatePipe,
    private storage: StorageService,
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    private titleService: Title,
    private groupApi: GroupsService,
    private api: ApiService,
    private memberApi: MembersService,
    private logger: ErrorHelpersService,
    private loadingService: LoaderService,
    private uploadApi: UploadService,
    private clipboard: Clipboard,
    private toastr: ToastrService,
    private http: HttpClient,
    private modalService: NgbModal,
    private error_handler: ErrorHelpersService,
    public ability: PureAbility<any>,
    private service: DashboardService,
    private messagingService: ProfileMessagingService,
  ) {
    this.dateTimePipe = new DateTimePipe();
    this.messagingService.parentMailCopied$.subscribe(link => {
      this.parent_copy_body = link;
    });
  }


  can(action: Actions, subject: Subjects): boolean {
    // if(subject === Subjects.Coach){
    //   console.log(action, subject, this.ability.can(action, subject))
    // }
    // if (!action || !subject) return true;
    return this.ability.can(action, subject);
  }

  canAny(action: Actions, subjects: Subjects[]): boolean {
    return subjects.some(subject => this.ability.can(action, subject));
  }

  ngOnInit(): void {
    // this.date.setFullYear(this.date.getFullYear() - 9);
    this.id = this.storage.getJsonValue(USER_ID)
    this.userid = this.route.snapshot.paramMap.get('id')
    this.class_id = this.route.snapshot.queryParamMap.get('class_id') || null
    this.user.basic_information = {
      email: "",
      gender: "",
      name: "",
      address: [{
        addr1: "",
        city: "",
        district: "",
        pincode: "",
        state: "",
      }],
      // jersey_sizes : [{
      //   t_shirt : "",
      //   shorts : "",
      //   shoe: "",
      // }]
    }
    this.user.sports = [{ sport_name: "" }]
    this.achievement.basic_information = {
      email: "",
      gender: "",
      address: [{
        addr1: "",
        city: "",
        district: "",
        pincode: "",
        state: "",
      }],
      achievement: []
    }
    this.locale_data = this.storage.getJsonValue(LOCALIZATION)


    this.filteredPhoneCodes1 = this.phoneCodeControl1.valueChanges.pipe(
      startWith(''),
      map(value => this.filterPhoneCodes(value))
    );
    this.filteredPhoneCodes2 = this.phoneCodeControl2.valueChanges.pipe(
      startWith(''),
      map(value => this.filterPhoneCodes(value))
    );

    this.getUserData()
    this.getUserRole()
    // this.getParentData()
    this.getUserAchievement()
    // this.getUserPdDetails();
    // this.getUserHomework()
    // this.getFeeds()
    // this.getUserAttendence();
    // this.getAcademicStats()

    this.formsCollection()
    this.loadEducational()
    if (this.class_id) {
      this.loadOverallReport()
    }


    this.getJoiningInfo()
    // this.getPlayerLinks()
  }



  openCoverUploadModal(mediumModalContent: any, type: any) {
    this.upload_image_type = type
    this.modalService.open(mediumModalContent, cropperConfig as NgbModalOptions);
  }

  // Image cropper support

  /**
   * Binds the selected image file to the cropper element.
   *
   * Saves the selected file for furthur use.
   * @param event File select event.
   */
  fileChangeEventDp(event: any, isCoverImage: boolean): void {
    const fileName = (document.getElementById("myfileid2") as HTMLInputElement).value;
    const idxDot = fileName.lastIndexOf(".") + 1;
    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      this.fileSelect = false
      if (isCoverImage) {
        this.coverImageChangedEvent = event;
      } else {
        this.profileImageChangedEvent = event;
      }
      // this.imageChangedEvent = event;
      this.file2 = event.target.files
    } else {
      alert("Only jpg/jpeg and png files are allowed!");
    }
  }

  /**
   * Opens a file browser
   *
   * @returns
   */
  openFileSelectDp() {
    // $('#myfileid').trigger('click');
    this.myButton.nativeElement.click();
    return true;
  }


  /**
 * Called after image has been cropped.
 *
 * Text on the button is changed.
 * Boolen is set to denote that image is cropped.
 * Image upload process is started.
 */
  async uploadCropped() {
    if (this.file2) {
      this.upload = "Class Image Uploaded!"
      this.afterCrop = true
      // var date = new Date()
      // var filepath = this.storage.getJsonValue(USER_ID).concat(`/${this.upload_image_type}/${this.file[0].name}`)
      let filepath = this.storage.getJsonValue(USER_ID).concat(`/${this.upload_image_type}`)
      filepath = filepath.replace(/ /g, "_");
      // console.log(filepath, this.croppedImage, this.upload_image_type)
      const upload_response = await this.uploadApi.azureuploadCropped(this.file2[0], storage_user, container_user, filepath, this.croppedImage)
      this.uploadPath = upload_response.uploadpath
      this.service.editUserImage(this.userid, this.upload_image_type, this.uploadPath).subscribe({
        next:(res: any) => {
          this.error_handler.logger(res)
          if (this.upload_image_type === "dp") {
            this.user.basic_information.dp = this.uploadPath
            // this.storage.setJsonValue(USER_DP, this.uploadPath)
          } else {
            this.user.basic_information.cover_photo = this.uploadPath
          }
          // this.storage.setJsonValue(USER_SUPER, this.user)
        }
      })
    } else {
      this.toastr.warning(`Please select a image to upload.`, 'Choose Image', {
        progressBar: true,
        closeButton: true,
      })
    }
  }


  imageCropped(event: ImageCroppedEvent) {
    // this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(!event.objectUrl?"": event.objectUrl);
    this.croppedImage = event.base64
    // event.blob can be used to upload the cropped image
  }
  imageLoaded(image: LoadedImage) {
      // show cropper
      this.error_handler.logger(image)
  }
  cropperReady() {
      // cropper ready
      this.error_handler.logger('cropper component ready')
  }
  loadImageFailed() {
      // show message
      this.error_handler.handleError('image load error')
  }


  get activeSizeList() {
    return this.user.basic_information.gender === 'F'
      ? this.womenSizes
      : this.unisexSizes;
  }

  get activeSizeListShorts() {
    return this.user.basic_information.gender === 'F'
      ? this.womenShortsSizes
      : this.unisexShortsSizes;
  }

  get activeSizeListShoes() {
    return this.user.basic_information.gender === 'F'
      ? this.womensShoeSizes
      : this.mensShoeSizes;
  }



  private filterPhoneCodes(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.phoneCode.filter((option: any) =>
      option.name.toLowerCase().includes(filterValue) ||
      option.dial_code.toLowerCase().includes(filterValue)
    );
  }


  selectPhoneCode(event: any) {
    this.parentPhoneCode1 = event.option.value;
  }

  openParentEdit1() {
    this.tempParent1 = JSON.parse(JSON.stringify(this.user.parent_1_info));
    if(this.tempParent1.basic_information?.phone){
      setTimeout(() => {
        const phone = this.tempParent1.basic_information?.phone[0];
        if (phone) {
          this.phoneCodeControl1.setValue(phone.country_code);
          this.parentPhoneNumber1 = phone.number;
          this.parentPhoneCode1 = phone.country_code;
        }
      });
    }
    this.parentEdit()
  }

  parentEdit() {
    this.parent_edit = !this.parent_edit
  }


  selectPhoneCode2(event: any) {
    this.parentPhoneCode2 = event.option.value;
  }

  openParentEdit2() {
    this.tempParent2 = JSON.parse(JSON.stringify(this.user.parent_2_info));
    if(this.tempParent2?.basic_information?.phone){
      setTimeout(() => {
        const phone = this.tempParent2?.basic_information?.phone[0];
        if (phone) {
          this.phoneCodeControl2.setValue(phone.country_code);
          this.parentPhoneNumber2 = phone.number;
          this.parentPhoneCode2 = phone.country_code;
        }
      });
    }
    this.parentEdit2()
  }

  parentEdit2() {
    this.parent_edit2 = !this.parent_edit2
  }


  updateParentEdit() {
    this.loadingService.show()

    if(this.tempParent1.basic_information.name.first_name.trim() === ""){
      this.toastr.warning(`Parent first name is mandatory for parent info.`, 'Parent name required!', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    } else if(this.tempParent1.basic_information.email.toLowerCase().trim() === ""){
      this.toastr.warning(`Parent email is mandatory for parent info.`, 'Parent email required!', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    } else if (!isPhoneCodePairValid(this.parentPhoneCode1, this.parentPhoneNumber1)) {
      this.toastr.warning(`Please enter both the country code and phone number, or leave both blank.`, 'Phone number incomplete', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    }
    const user_data = {
      "_id": this.tempParent1._id,
      "student_id": this.user._id,
      "country": this.user.country?.[0] === '000000000000000000000000' ? "" : (this.user.country?.[0] ? this.user.country[0].toLowerCase().trim() : ""),
      "basic_information": {
        "name": {
          "first_name": this.tempParent1.basic_information.name.first_name.trim(),
          "middle_name": this.tempParent1.basic_information.name.middle_name.trim(),
          "last_name": this.tempParent1.basic_information.name.last_name.trim(),
          "display_name": this.tempParent1.basic_information.name.display_name
        },
        "email": this.tempParent1.basic_information.email.toLowerCase().trim(),
        "phone": [
          {
            country_code: this.parentPhoneCode1,
            number: this.parentPhoneNumber1,
            is_primary: true
          }
        ]
      },
      "user_name": this.tempParent1.user_name
    }
    // console.log(user_data)
    this.api.editPersonalParent(user_data, this.id).subscribe(() => {
      this.toastr.success(`Parent info has been edited.`, 'Profile edited!', {
        progressBar: true,
        closeButton: true,
      })
      this.getUserData()
      this.loadingService.hide()
      this.parent_edit = false
    })

  }

  updateParentEdit2() {
    this.loadingService.show()
    console.log(this.tempParent2)
    if(this.tempParent2.basic_information.name.first_name.trim() === ""){
      this.toastr.warning(`Parent first name is mandatory for parent info.`, 'Parent name required!', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    } else if(this.tempParent2.basic_information.email.toLowerCase().trim() === ""){
      this.toastr.warning(`Parent email is mandatory for parent info.`, 'Parent email required!', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    } else if (!isPhoneCodePairValid(this.parentPhoneCode2, this.parentPhoneNumber2)) {
      this.toastr.warning(`Please enter both the country code and phone number, or leave both blank.`, 'Phone number incomplete', {
        progressBar: true,
        closeButton: true,
      });
      this.loadingService.hide()
      return
    }
    const user_data = {
      "_id": this.tempParent2._id,
      "student_id": this.user._id,
      "country": this.user.country?.[0] === '000000000000000000000000' ? "" : (this.user.country?.[0] ? this.user.country[0].toLowerCase().trim() : ""),
      "basic_information": {
        "name": {
          "first_name": this.tempParent2.basic_information.name.first_name.trim(),
          "middle_name": this.tempParent2.basic_information.name.middle_name.trim(),
          "last_name": this.tempParent2.basic_information.name.last_name.trim(),
          "display_name": this.tempParent2.basic_information.name.display_name
        },
        "email": this.tempParent2.basic_information.email.toLowerCase().trim(),
        "phone": [
          {
            country_code: this.parentPhoneCode2,
            number: this.parentPhoneNumber2,
            is_primary: true
          }
        ]
      },
      "user_name": this.tempParent2.user_name
    }
    // console.log(user_data)
    // return
    this.api.editPersonalParent2(user_data, this.id).subscribe(() => {
      this.toastr.success(`Parent info has been edited.`, 'Profile edited!', {
        progressBar: true,
        closeButton: true,
      })
      this.getUserData()
      this.loadingService.hide()
      this.parent_edit2 = false
    })

  }


  getJoiningInfo() {
    this.auth.fetchUserJoining(this.id, this.userid).subscribe({
      next: (res) => {
        this.user_join = res.data;
        if (this.user_join?.join_date === "0001-01-01T00:00:00Z") {
          this.tempJoinDate = this.user?.join_date ? new Date(this.user.join_date) : null;
        } else {
          this.tempJoinDate = this.user_join?.join_date ? new Date(this.user_join.join_date) : null;
        }
        // console.log(this.user_join, "user join ");
      },
      error: (error) => {
        console.log("error:", error);
      },
      complete: () => {
        console.log("Request complete");
      }
    });
  }


  toggleEditJoinDate() {
    // this.tempJoinDate = null
    this.editingJoinDate = true;
    this.getJoiningInfo()
    // this.tempJoinDate = this.user_join?.join_date
    //   ? new Date(this.user_join.join_date).toISOString().substring(0, 10)
    //   : '';
  }


  cancelJoinDateEdit() {
    this.editingJoinDate = false;
    this.tempJoinDate = null;
    this.getJoiningInfo()
  }

  onJoinDateChange(event: any) {
    this.tempJoinDate = event.value;
  }


saveJoinDate() {
  if (!this.tempJoinDate){
    this.editingJoinDate = false;
    return;
  }

  const updatedUser = {
    _id: this.user_join._id,
    userid: this.user._id,
    academyid: this.id,
    groupid: "000000000000000000000000",
    profile_type: "member",
    status: "active",
    member_count: 0,
    coach_count: 0,
    roles: {
      page_role: "member",
      career_role: "member"
    },
    user: {},
    join_date: new Date(this.tempJoinDate).toISOString(),
    coach_id: "000000000000000000000000"
  };

  // console.log('Payload', updatedUser);

  this.auth.updateUserJoiningDate(this.user_join._id, updatedUser).subscribe({
    next: (res) => {
      this.toastr.success('Joining date updated successfully.', 'Success');
      this.user_join.join_date = updatedUser.join_date;
      this.editingJoinDate = false;
    },
    error: (err) => {
      console.error('Error:', err);
      this.toastr.error('Error updating joining date.', 'Error');
    },
  });
}



  loadFilters(){
    this.initLocaleData()
    this.filteredOptionsPhoneCodes = this.phoneCodeControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterPhoneCodes(value || '')),
    );
  }


  getUserRole() {
    const route = this.id ? `${this.API_URL}/permissions/users/${this.userid}/${this.id}` : `${this.API_URL}/permissions/users/${this.userid}`
    this.http.get(route).subscribe({
      next:(res: any)=>{
        this.role = res?.role|| {};
        // console.log(this.role)
      },
      error:(error)=>{
        console.error(error)
      }
    })
  }

  checkUser() {
    this.existingUser = false
    this.isValid = true
    const email = this.user.basic_information.email.trim();
    // console.log(this.email, this.emailFormatValid, this.email != "")
    if (email != "") {
      this.auth.checkEmail(email.toLowerCase()).subscribe((result: any) => {
        if (result.active_status === STATUS_ACTIVE
          || result.active_status === "new"
          || result.active_status === STATUS_PENDING_CONSENT
          || result.active_status === STATUS_PENDING_PASSWORD) {
          this.auth.fetchUserId(email.toLowerCase()).subscribe((res: any) => {
            this.memberApi.isMember(this.id, res.id).subscribe((members: any) => {
              this.already_a_academy_member = members["members"]
              this.auth.fetchUserData(res.id).subscribe((user: any) => {
                if (user.data.profile_type.includes("Academy")) {
                  this.toastr.warning("This email owner is a academy, a academy cannot be a member to another academy.", 'Email owner is a Academy', {
                    progressBar: true,
                    closeButton: true
                  })
                  this.isValid = false
                }else if(result.profile_type.includes("Parent")){
                  this.toastr.warning("This member is already part of Dartle as a parent, a parent cannot be a member of the academy.", "Member Already Registered as Parent")
                  this.isValid = false
                }else if (this.already_a_academy_member) {
                  this.toastr.warning("This email owner is already a member of the academy.", 'Email owner is a Member', {
                    progressBar: true,
                    closeButton: true
                  })
                  this.isValid = false
                }
                else {
                  this.existingUser = true
                  this.isValid = false
                  this.toastr.info("This email owner is already a Dartle member.", 'Info', {
                    progressBar: true,
                    closeButton: true
                  });
                }
              })
            })
          })
        }
      },
        (error: any) => {
          console.log(error)
        })
    }
  }

  private _filterPhoneCodes(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.phoneCode.filter((option: any) => option.name.toLowerCase().includes(filterValue) || option.dial_code.toLowerCase().includes(filterValue));
  }

  initLocaleData() {
    this.phoneCodeControl.setValue(this.locale_data.phone)
    // console.log(this.locale_data)
  }

  loadOverallReport() {
    this.reportsapiService.getOverallReport(this.class_id, this.userid).subscribe((res: any) => {
      this.profile_report = res["profile_info"] || []
      // this.class_info = res["class_info"] || []
      // this.coach_infos = res["coach_infos"] || []
      // this.pd_info = res["pd_info"] || []
      // this.getGender(this.profile_report?.basic_information?.gender)
    })
  }

  formsCollection() {
    this.addEducation = new FormGroup({
      university: new FormControl('', [Validators.required]),
      course: new FormControl('', [Validators.required]),
      year_in: new FormControl('', [Validators.required]),
      year_out: new FormControl('', [Validators.required]),
    })

    // this.editContact = new FormGroup({
    //   phone: new FormControl('', [Validators.required]),
    //   mail: new FormControl('', [Validators.required]),
    //   address: new FormControl('', [Validators.required]),
    // })

    this.editProfile = new FormGroup({
      first_name: new FormControl('', [Validators.required]),
      last_name: new FormControl(''),
      middle_name: new FormControl(''),
      user_name: new FormControl('', [Validators.required]),
      date_of_birth: new FormControl('', [Validators.required]),
      gender_: new FormControl('', [Validators.required]),
      t_shirt_size: new FormControl(''),
      shorts_size: new FormControl(''),
      shoe_size: new FormControl(''),
    });

    this.editProfile.get('user_name')?.disable();

    // this.addAchievments = new FormGroup({
    //   achievment_name: new FormControl('', [Validators.required]),
    //   year: new FormControl(new Date(), [Validators.required]),
    // })

    this.preferedFoods = new FormGroup({
      prefered_foods: new FormControl('', [Validators.required]),
    })

  }


  contactEdit() {
    this.getUserData()
    if (!this.contact_edit) {
      this.originalContactDetails = {
        phone: { ...this.phone },
        alternative_email: this.user.basic_information.alternative_email,
        address: this.user.basic_information.address ? [...this.user.basic_information.address] : [{
          addr1: "",
          addr2: "",
          city: "",
          district: "",
          state: "",
          pincode: "",
          country_id: "5ddf772af7cbe64bdc7e0bbd",
          country: "",
        }],
      };
    } else {
      // Restore original values if cancelling
      this.phone = { ...this.originalContactDetails.phone };
      this.user.basic_information.alternative_email = this.originalContactDetails.alternative_email;
      this.user.basic_information.address = [...this.originalContactDetails.address];
    }
    this.contact_edit = !this.contact_edit;
  }

   contactEditDone(){
    this.contact_edit = !this.contact_edit;
    this.originalContactDetails = {
      phone: { ...this.phone },
      alternative_email: this.user.basic_information.alternative_email,
      address: [...this.user.basic_information.address],
    };
   }

  characteristicsEdit() {
    this.characteristics_edit = !this.characteristics_edit
  }

  updateBios() {
    this.loadingService.show()
    const data = {
      dob: this.user.basic_information.dob,
      gender: this.user.basic_information.gender,
      height: +this.user.basic_information.height,
      weight: +this.user.basic_information.weight,
      bmi: +this.user.basic_information.bmi,
      blood_type: this.user.basic_information.blood_type,
    }
    // console.log(data)
    this.api.editBios(this.userid, data).subscribe({
      next: () => {
        this.loadingService.hide()
        this.characteristicsEdit()
      },
      error: (e) => {
        this.loadingService.hide()
      }
    })
  }

  preferenceEdit() {
    this.preference = !this.preference
  }
  educationalQuali() {
    this.educationalQ = !this.educationalQ
  }
  licensesQuali() {
    this.licensesEdit = !this.licensesEdit
  }
  personalEdit() {
    this.visible = !this.visible
    this.getUserData();
    this.formsCollection()
  }

  onImgError(event: any) {
    event.target.src = 'images/samples/ic_profile.png'
  }


  usernamePetWords = [
    "mink", "crab", "otter", "falcon", "panther", "sparrow", "badger", "heron", "lynx", "weasel",
    "raven", "beetle", "gecko", "wombat", "puffin", "cobra", "ferret", "jackal", "mongoose", "tapir",
  ];

  generateUsername() {
    if (this.editProfile.valid) {
      if (this.editProfile.controls['last_name'].value && this.editProfile.controls['first_name'].value) {
        this.username = `${this.editProfile.controls['first_name'].value}.${this.editProfile.controls['last_name'].value}`;
      } else if (this.editProfile.controls['first_name'].value) {
        this.username = `${this.editProfile.controls['first_name'].value}`;
      } else {
        this.username = '';
      }
      this.username = this.username.replace(/\s+/g, '-').toLowerCase();
      this.resolveUniqueUsername(this.username, 0);
    }
  }

  // resolveUniqueUsername actually verifies the candidate is free, escalating through a
  // digit suffix and then a pet-name suffix on collision, instead of assuming a single
  // random suffix is enough.
  resolveUniqueUsername(candidate: string, tier: number) {
    this.auth.checkUsername(candidate).subscribe((res: any) => {
      if (!res.success) {
        this.username = candidate;
        this.usernameValid = true;
      } else if (tier === 0) {
        this.resolveUniqueUsername(`${candidate}${this.makeRandom(4)}`, 1);
      } else if (tier < 6) {
        const word = this.usernamePetWords[Math.floor(Math.random() * this.usernamePetWords.length)];
        this.resolveUniqueUsername(`${candidate}.${word}`, tier + 1);
      } else {
        // Safety net so this can never loop forever.
        this.username = `${candidate}${Date.now()}`;
        this.usernameValid = true;
      }
    });
  }


  checkUserName(generate = false) {
    this.auth.checkUsername(this.username).subscribe((res: any) => {
      if (res.success) {
        if (generate) {
          // console.log(this.usernameValid)
          this.username = `${this.username}${this.makeRandom(4)}`
          // console.log(this.username)
        } else {
          this.usernameValid = true
        }
      } else {
        this.usernameValid = false
      }
    })
  }

  makeRandom(lengthOfCode: number) {
    const possible = "0123456789";
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  fileChangeEvent(event: any): void {
    const fileName = (document.getElementById("myfileid") as HTMLInputElement).value;
    const idxDot = fileName.lastIndexOf(".") + 1;
    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    this.file = event.target.files;

    if (extFile === "jpg" || extFile === "jpeg" || extFile === "png" || extFile === "pdf") {
      this.uploadAttachment()
    } else {
      this.toastr.warning(`Please select a proper file type (JPG, PNG, PDF).`, 'File type invalid.', {
        progressBar: true,
        closeButton: true,
      });
    }
  }

    async uploadAttachment() {
      if (this.file) {
        const fileName = this.file[0].name;
        if (/[\\/\\:?*"<>|#]/.test(fileName)) {
          this.toastr.warning(`File name contains special characters (/\\:?*"<>|#). Please change the file name before uploading.`, 'Invalid file name', {
            progressBar: true,
            closeButton: true,
          });
          return;
        }
        const uploadPath = `${this.id}/${this.id}/licence`;
        try {
          const endPath = await this.uploadApi.azureupload(this.file[0], storage_user, container_user, uploadPath)
          // const endPath = await this.uploadApi.azureuploadCropped(this.file[0], storage_user, container_user, uploadPath, this.croppedImage);
          const fileType = endPath.upload_file_type // "image" for "image/png", etc.

          // Adding the uploaded file info to licenseList
          this.licenses.push({
            name: endPath.upload_file,
            path: endPath.uploadpath,
            type: fileType
          });

          // Show success message
          this.auth.updateUserLicenses(this.userid, this.licenses).subscribe({
            next:()=>{
              this.toastr.success('File uploaded successfully.', 'Upload successful', {
                progressBar: true,
                closeButton: true,
              });
            }
          })
          // console.log(this.licenseList)
        } catch (error) {
          console.error("Upload failed:", error);
          this.toastr.error('File upload failed. Please try again.', 'Upload failed', {
            progressBar: true,
            closeButton: true,
          });
        }
      }
  }

  // editProfileInfo() {
  //   this.submitted = true
  //   this.fnameValid = this.editProfile.controls['first_name'].value.trim().length == 0
  //   this.lnameValid = this.editProfile.controls['last_name'].value.trim().length == 0
  //   const isUsername = this.editProfile.controls['user_name'].value.length == 0
  //   const dob = new Date(this.editProfile.controls['date_of_birth'].value);
  //   const today = new Date();
  //   if (dob < today) {
  //     this.dateValid = false
  //   }
  //   const isNameValid = !isUsername && !this.fnameValid

  //   const isoDob = this.datepipe.transform(dob, 'YYYY-MM-dd')
  //   if (this.submitted && isNameValid && !this.dateValid) {
  //     const data1 = {
  //       "dob": isoDob,
  //       "gender": this.editProfile.controls['gender_'].value,
  //     }
  //     this.api.editDobGender(data1, this.userid).subscribe(() => {
  //     })
  //     const user_data = {
  //       "_id": this.userid,
  //       "basic_information": {
  //         "name": {
  //           "first_name": this.editProfile.controls['first_name'].value.trim(),
  //           "middle_name": "",
  //           "last_name": this.editProfile.controls['last_name'].value.trim(),
  //           "display_name": ""
  //         },
  //         "email": this.user.basic_information.email.toLowerCase().trim()
  //       },
  //       "user_name": this.editProfile.controls['user_name'].value
  //     }
  //     this.api.editPersonal(user_data, this.userid).subscribe(() => {
  //       this.toastr.success(`Personal info has been edited.`, 'Profile edited!', {
  //         progressBar: true,
  //         closeButton: true,
  //       })
  //     })
  //     this.visible = false
  //     this.formsCollection()
  //   }else{
  //     this.toastr.warning(`Please enter required data`, `Data required.`)
  //   }
  // }


  editProfileInfo() {
    this.submitted = true;
    this.fnameValid = this.editProfile.controls['first_name'].value.trim().length == 0;
    this.lnameValid = this.editProfile.controls['last_name'].value.trim().length == 0;
    const isUsername = this.editProfile.controls['user_name'].value.length == 0;
    const dob = new Date(this.editProfile.controls['date_of_birth'].value);
    const today = new Date();

    if (dob < today) {
      this.dateValid = false;
    }

    const isNameValid = !isUsername && !this.fnameValid;
    const isoDob = this.datepipe.transform(dob, 'YYYY-MM-dd');

    if (this.submitted && isNameValid && !this.dateValid) {
      const data1 = {
        dob: isoDob,
        gender: this.editProfile.controls['gender_'].value,
        jersey_sizes: {
          t_shirt: this.editProfile.controls['t_shirt_size'].value,
          shorts: this.editProfile.controls['shorts_size'].value,
          shoe: this.editProfile.controls['shoe_size'].value.toString()
        }
      };

      this.api.editDobGender(data1, this.userid).subscribe(() => {
        // this.toastr.success(`Personal info has been edited.`, 'Profile edited!', {
        //   progressBar: true,
        //   closeButton: true,
        // })
      });

      const user_data = {
        _id: this.userid,
        basic_information: {
          name: {
            first_name: this.editProfile.controls['first_name'].value.trim(),
            middle_name: this.editProfile.controls['middle_name'].value.trim(),
            last_name: this.editProfile.controls['last_name'].value.trim(),
            display_name: ""
          },
          email: this.user.basic_information.email.toLowerCase().trim(),
          jersey_sizes: data1.jersey_sizes
        },
        user_name: this.editProfile.controls['user_name'].value
      };

      this.api.editPersonal(user_data, this.userid).subscribe(() => {
        this.toastr.success(`Personal info has been edited.`, 'Profile edited!', {
          progressBar: true,
          closeButton: true,
        });
      });

      this.visible = false;
      this.formsCollection();
    } else {
      this.toastr.warning(`Please enter required data`, `Data required.`);
    }
  }


  openFileSelect() {
    $('#myfileid').trigger('click');
    return true;
  }

  onDeleteFile(event: { file: any; index: number }) {
    // console.log('Delete file:', event.file, 'at index:', event.index);
    // Example: remove from array by index
    // this.posts.splice(event.index, 1);
    this.deleteUploads(event.file.path, event.index)
  }

  async deleteUploads(url: any, pos: any) {

      // const delete_file = this.group_members[this.selected_player].scores[score_pos].array[metric_pos].images[pos].url.split('amazonaws.com/')[1]
        const delete_file = url.split(`windows.net/${container_user}/`)[1];
      // console.log(storage_user, container_user,delete_file)
        const response = await this.uploadApi.azuredelete(storage_user, container_user, delete_file)
        if (response.upload_status == 200) {
            this.toastr.success(`The media file was deleted from the metric.`, `Deleted`)
            this.licenses.splice(pos, 1)
            // this.moduleDetails.session_feedback.files = this.uploadfiles
            this.auth.updateUserLicenses(this.userid, this.licenses).subscribe({
              next:(res: any)=>{
                // console.log(res)
              }
            })
        }
    // }
  }

  loadEducational() {
    this.api.getEducational(this.userid).subscribe({
      next: (res: any) => {
        this.educational = res
        // console.log(this.educational)
        this.education = this.educational[0]?.basic_information?.education
        if (this.education == null || this.education == undefined || this.education.length == 0) {
          this.educational = []
        }
        // console.log(this.education)
      },
      error: (e) => {
        console.error(e)
        this.is_loading_educational = false
      },
      complete: () => {
        this.is_loading_educational = false
      }
    });
  }

  validateStartYear() {
    const yearInControl = this.addEducation.controls['year_in'];
    const yearInValue = parseInt(yearInControl.value, 10);

    if (yearInValue < 1900 || isNaN(yearInValue)) {
      yearInControl.setValue(1900);
      this.toastr.warning('Enter a valid year.', 'Validation Error', {
        progressBar: true,
        closeButton: true,
      });
    }
  }

  validateEndYear() {
    const yearOutControl = this.addEducation.controls['year_out'];
    const yearOutValue = parseInt(yearOutControl.value, 10);

    if (yearOutValue > 2900 || isNaN(yearOutValue)) {
      yearOutControl.setValue(2900);
      this.toastr.warning('Enter a valid year.', 'Validation Error', {
        progressBar: true,
        closeButton: true,
      });
    }
  }

  createEducation() {
    this.createClick = true;
    if (this.addEducation.valid) {
      const universityName = this.addEducation.controls['university'].value.trim();
      const courseName = this.addEducation.controls['course'].value.trim();
      const yearIn = this.addEducation.controls['year_in'].value;
      const yearOut = this.addEducation.controls['year_out'].value;

      if (universityName === "" || courseName === "" || yearIn === "" || yearOut === "") {
        this.toastr.warning('University name, Course name, Year in, and Year out cannot be empty.', 'Validation Error', {
          progressBar: true,
          closeButton: true,
        });
        this.createClick = false;
        return;
      }

      if (yearIn >= yearOut) {
        this.toastr.error('Year In should be less than Year Out', 'Validation Error', {
          progressBar: true,
          closeButton: true,
        });
        this.createClick = false;
        return;
      }

      const data = {
        "id": this.userid,
        "university_name": universityName,
        "course_name": courseName,
        "year_in": yearIn,
        "year_out": yearOut,
      };

      this.api.createEducation(data).subscribe(() => {
        this.toastr.success(`Education qualification has been added.`, 'Education Added!', {
          progressBar: true,
          closeButton: true,
        });
        this.loadEducational();
        this.educationalQuali();
        this.addEducation.controls['university'].setValue("");
        this.addEducation.controls['course'].setValue("");
        this.addEducation.controls['year_in'].setValue("");
        this.addEducation.controls['year_out'].setValue("");
        this.createClick = false;
      });
    } else {
      this.toastr.warning('Fields cannot be empty.', 'Validation Error', {
        progressBar: true,
        closeButton: true,
      });
      this.createClick = false;
    }
  }

  deleteEducation(index: any) {
    const deleted = this.educational[0].basic_information.education[index]
    // console.log(deleted)
    this.api.deleteEducations(this.userid, deleted.id).subscribe(() => {
      this.toastr.success(`Selected education has been successfully deleted.`, 'Deleted successfully', {
        progressBar: true,
        closeButton: true,
      })
      this.loadEducational()
    })
  }



  preferenceChange(data: any) {
    var datas = {
      "prefered_position": data,
      "is_nutritionist_needed": this.user?.basic_information?.is_nutritionist_needed,
      "prefered_foods": this.user?.basic_information?.prefered_foods,
    }
    this.api.preferenceChanging(datas, this.userid).subscribe({
      next: (res) => {
        this.toastr.success(`Preference has been edited.`, 'Edited!', {
          progressBar: true,
          closeButton: true,
        });
      },
      error: (err) => {
        console.error('Preference update failed:', err);
      },
      complete: () => {
        console.log('Preference change request completed.');
        this.getUserData()
      }
    });
  }

  checkboxNutrition(data: any) {
    const datas = {
      "prefered_position": this.user?.basic_information?.prefered_position,
      "is_nutritionist_needed": data,
      "prefered_foods": this.user?.basic_information?.prefered_foods,
    }
    this.api.preferenceChanging(datas, this.userid).subscribe(() => {
      this.getUserData()
      this.toastr.success(`The need for nutritionist status is updated.`, `Profile Updated.`)
    })
    // console.log(datas)
  }

  // To add new foods into the list
  preferedFoodsList() {
    if (this.preferedFoods.valid) {
      const foodslist = this.preferedFoods.controls['prefered_foods'].value.trim();
      if (foodslist != "") {
        let foodPass: string[] = foodslist.split(',').map((food: string) => food.trim());
        foodPass = foodPass.filter(food => food !== "");
        // Merge the existing preferred foods with the new foods
        const existingFoods = this.user?.basic_information?.prefered_foods || [];
        const mergedFoods = existingFoods.concat(foodPass);

        const data = {
          "prefered_position": this.user?.basic_information?.prefered_position,
          "is_nutritionist_needed": this.user?.basic_information?.is_nutritionist_needed,
          "prefered_foods": mergedFoods,
        };
        // console.log(data);
        this.api.preferenceChanging(data, this.userid).subscribe(() => {
          // Perform any actions upon successful update
          this.preferedFoods.controls['prefered_foods'].setValue("")
          this.toastr.success(`Prefered foods list is updated.`, `Profile Updated.`)
          this.getUserData();
        });
      }
    }
  }

  deleteFoods(index: any) {
    const existingFoods = this.user?.basic_information?.prefered_foods || [];
    // Remove the food item at the specified index
    existingFoods.splice(index, 1);
    const data = {
      "prefered_position": this.user?.basic_information?.prefered_position,
      "is_nutritionist_needed": this.user?.basic_information?.is_nutritionist_needed,
      "prefered_foods": existingFoods,
    };
    // console.log(data);
    this.api.preferenceChanging(data, this.userid).subscribe(() => {
      this.getUserData();
    });
  }

  toUTC(date: Date): Date {
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    ));
  }

  mapProfileToSubject(type: string): Subjects | null {
    const map: Record<string, Subjects> = {
      Player: Subjects.Player,
      Coach: Subjects.Coach,
      Admin: Subjects.Admin
    };

    return map[type] || null;
  }

  canProfile(view: Actions, profileTypes: string[]): boolean {
    if (!profileTypes?.length) return false;

    return profileTypes.some(type => {
      const subject = this.mapProfileToSubject(type);
      console.log(subject)
      return subject && this.ability.can(view, subject);
    });
  }

  getUserData() {
    this.auth.fetchUserData(this.userid).subscribe((res) => {
      this.user = res.data
      this.active_status = res.data.active_status
      this.profile = this.user?.profile_type
      this.isProfileLoaded = true;
      this.gender = this.user.basic_information.gender
      this.fname = this.user.basic_information.name.first_name
      this.lname = this.user.basic_information.name.last_name
      this.mname = this.user.basic_information.name.middle_name
      this.full_name = this.mname ? `${this.fname} ${this.mname} ${this.lname}` : `${this.fname} ${this.lname}`
      this.username = this.user.user_name
      this.prefered_position = this.user?.basic_information?.prefered_position || ''
      // this.date = new Date(this.user.basic_information.dob.toString());
      // console.log(this.user)
      if(!this.user.basic_information.jersey_sizes){
        this.user.basic_information = {
          jersey_sizes : [{
            t_shirt : "",
            shorts : "",
            shoe: "",
          }]
        }
      }
      // this.user.basic_information.jersey_sizes = []
      const dobValue = this.user.basic_information.dob;
      const utc = new Date(dobValue);

      // Extract UTC date parts
      const year = utc.getUTCFullYear();
      const month = utc.getUTCMonth(); // 0-indexed
      const day = utc.getUTCDate();
      // Create local Date without timezone shift
      this.date = new Date(year, month, day); // ✅ safe for datepicker
      this.user.basic_information.dob = new Date(year, month, day); // ✅ safe for datepicker
      if (this.user.sports == null || this.user.sports == null) {
        this.user.sports = []
      }
      if (this.user.basic_information.dob == "0001-01-01T00:00:00Z") {
        this.vaildDate = false
        this.user.basic_information.dob = new Date("1991-01-01T00:00:00Z")
      }
      if (this.user.basic_information.licenses){
        this.licenses	= this.user.basic_information.licenses
        // console.log(this.licenses)
      }
      // console.log(this.user, "useerr")
      // console.log(this.date)
      try {
        this.phone = this.user?.basic_information?.phone?.filter((ele: any) => {
          return ele.is_primary = true
        })[0]
        if(this.phone === undefined){
          this.phone = {
            country_code: "",
            number: "",
            is_primary: true,
          }
        }
      } catch (error: any) {
        this.logger.handleError(error)
      }
      if(!this.user?.basic_information?.address){
        this.addressEmpty = true
        this.user.basic_information.address = [{
          addr1:"",
          city:"",
          district:"",
          state:"",
        }]
      }
      else if (this.user?.basic_information?.address) {
        if (
          this.user?.basic_information?.address[0]?.addr1?.length == 0 &&
          this.user?.basic_information?.address[0]?.city?.length == 0 &&
          this.user?.basic_information?.address[0]?.district?.length == 0 &&
          this.user?.basic_information?.address[0]?.city?.length == 0 &&
          this.user?.basic_information?.address[0]?.state?.length == 0) {
          this.addressEmpty = true
          this.user.basic_information.address = [{
            addr1:"",
            city:"",
            district:"",
            state:"",
          }]
        }else{
          this.addressEmpty = false
        }
      }

      if(this.active_status === 'pending consent'){
        this.mode = "consent"
      }else{
        this.mode = "active"
      }
      const p1Email = this.user?.parent_1_info?.basic_information?.email;
      if (typeof p1Email === 'string' && p1Email.includes('@temp_parent_mail.com')) {
        this.user.parent_1_info.basic_information.email = '';
      }

      const p2Email = this.user?.parent_2_info?.basic_information?.email;
      if (typeof p2Email === 'string' && p2Email.includes('@temp_parent_mail.com')) {
        this.user.parent_2_info.basic_information.email = '';
      }

      const dob = this.user?.basic_information?.dob
      this.age = "-";
      if (dob !== "0001-01-01T00:00:00Z") {
          const birthDate = new Date(dob);
          const today = new Date();
          let ageDiff = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              ageDiff--;
          }
          this.age = ageDiff.toString();
      }
      // console.log(this.age)
      this.age = +this.age
      this.titleService.setTitle(`Profile - ${this.user.basic_information.name.first_name}`)
      // console.log(this.user)
      this.loadFilters()
    })
  }

  sendParentMail(parent: string, id: string) {
    this.messagingService.sendParentMail(this.id, parent, id, this.mode);
  }

  whatsapp(parent: string, id: string) {
    this.messagingService.whatsapp(this.id, id, parent);
  }

  getParentMail(parent: string, id: string) {
    this.messagingService.getParentMail(this.id, parent, id, this.mode);
  }

  getPlayerLinks(){
    this.messagingService.getPlayerLinks(this.id, this.userid, this.userid);
  }

  onPhoneNumberInput(event: Event) {
    const inputValue: string = (event.target as HTMLInputElement).value;
    const cleanedValue: string = inputValue.replace(/[^0-9+ ]/g, '');
    this.phone.number = cleanedValue;
  }

  onKeyDown(event: KeyboardEvent) {
    const keyCode: number = event.keyCode || event.which;
    if ((keyCode >= 65 && keyCode <= 90)) {
      event.preventDefault();
    }
  }

  onKeyDownBMI(event: any) {
    const keyCode: number = event.keyCode || event.which;
    if ((keyCode >= 65 && keyCode <= 90)) {
      event.preventDefault();
    } else {
      if (this.user.basic_information.weight > 0 && this.user.basic_information.height > 0) {
        const height = +this.user.basic_information.height
        const weight = +this.user.basic_information.weight
        const bmi = (weight / ((height * height)
          / 10000)).toFixed(2);
        this.user.basic_information.bmi = bmi
        // console.log({
        //   height: height,
        //   weight: weight,
        //   bmi: bmi,
        // })
      }
    }
  }

  editContactDetails() {
    this.loadingService.show()
    this.phone.country_code = this.phoneCodeControl.value
    const data = {
      basic_information: {
        email: this.user.basic_information.email.toLowerCase().trim(),
        alternative_email: this.user.basic_information.alternative_email.toLowerCase().trim(),
        socialmedia_link: this.user.basic_information.socialmedia_link,
        address: this.user.basic_information.address,
        phone: [this.phone],
      }
    }
    let pphoneValid = (/^([- +()0-9]+)$/.test(this.phone.number) && this.phone.number.length >= 7)
    if (this.phone.number.length == 0) {
      pphoneValid = true
    }
    const pairValid = isPhoneCodePairValid(this.phone.country_code, this.phone.number)
    // console.log(data, pphoneValid, pairValid)
    if (pphoneValid && pairValid) {
      // console.log(data)
      this.api.editContact(this.userid, data).subscribe({
        next: () => {
          // console.log(res)
          this.contactEditDone()
          this.getUserData()
          this.loadingService.hide()
          this.toastr.success(`Contact information is saved.`,`Profile saved.`)
        },
        error: (error: any) => {
          console.log("error:", error)
          this.loadingService.hide()
        }
      })
    } else if (!pairValid) {
      this.toastr.warning(`Please enter both the country code and phone number, or leave both blank.`, `Phone number incomplete`)
    } else {
      this.toastr.warning(`Please enter a valid phone number.`, `Phone number invalid.`)
    }
  }

  // getParentData(){
  //   this.api.getParent(this.userid).subscribe((res) => {
  //     this.parent = res['data']
  //     if (this.parent == null || this.parent == undefined) {
  //       this.parent = []
  //     }
  //   })
  //   console.log(this.parent)
  // }

  printPdInfoEndTimes() {
    // const totalDuration: number = 0;
    // console.log(this.OverSession)
    // for (let i = 0; i < this.OverSession.length; i++) {
    //   const pdInfo = this.OverSession[i].pd_info;
    //   const endTime = pdInfo ? pdInfo.end_time : 'N/A';
    //   const startTime = pdInfo ? pdInfo.start_time : 'N/A';
    //   // console.log(startTime, endTime)
    //   totalDuration += this.calculateDuration(startTime, endTime);
    // }
    // console.log(totalDuration, this.OverSession)
    // console.log(this.overall_info)
    this.dev_hours = `${this.overall_info?.attended_hours || 0}`;
  }

  calculateDuration(startTime: string, endTime: string): number {
    if (startTime === 'N/A' || endTime === 'N/A') {
      return 0;
    }

    const startDate = new Date("01/01/2007 " + startTime);
    const endDate = new Date("01/01/2007 " + endTime);

    const duration = endDate.getTime() - startDate.getTime();
    const hours = Math.floor(duration / (1000 * 60 * 60));

    return hours;
  }

  getUserAchievement() {
    this.api.fetchUserAchievement(this.userid).subscribe((res: any) => {
      this.achievement = res['data']
      if (this.achievement?.basic_information.achievement == null || this.achievement?.basic_information.achievement == undefined) {
        this.achievement.basic_information.achievement = []
      }
    })

    this.groupApi.getAssociatedGroupsOfId(this.userid).subscribe((res: any) => {
      for (const entry of (res['members'] || [])) {
        const elem = {
          "id": entry['_id'],
          "name": entry['basic_information']['name']['first_name'],
          "dp": entry['basic_information']['dp'],
          "coach": entry['associated_profiles'][0]['name'] || "Not Assigned",
          "coach_id": entry['profileid'],
        }
        this.members.push(elem)
      }

      this.coachs = res['coachs'] || []
      this.sports = res['sports'] || []
    })
  }


  getFeeds() {
    this.user_feed_loading = true;
    this.api.fetchFeeds(this.userid, this.id).subscribe((res: any) => {
      this.user_feed_loading = false;
      this.user_feed_all = res['data'] || []
      this.filterGallery('');
    }, () => {
      this.user_feed_loading = false;
    })
  }

  getGender(gender: string) {
    switch (gender.toLowerCase()) {
      case "M".toLowerCase():
        return "Male"
      case "F".toLowerCase():
        return "Female"
      default:
        return "Others"
    }
  }

  getUserPdDetails() {
    this.api.fetchProfilePdSessions(this.id, this.userid).subscribe((res: any) => {
      this.personal_dev_hours = res.attended_hours;
      this.pdStats = res;
      // console.log("pdStats", this.pdStats)
      this.pdStatSessions = [
        {
          type: "Pending Sessions",
          data: (res?.data || []).filter((pd: any) => {
            return !pd?.personality_dev?.is_present ||
              Date.parse(pd?.pd_info?.end_date) > Date.parse(new Date().toISOString());
          })
        },
        {
          type: "Completed Sessions",
          data: (res?.data || []).filter((pd: any) => {
            return pd?.personality_dev?.is_present &&
              Date.parse(pd?.pd_info?.end_date) <= Date.parse(new Date().toISOString());
          })
        }
      ]
      // console.log(this.pdStatSessions);
    })
  }


  getUserHomework() {
    this.api.fetchProfileHomework(this.id, this.userid).subscribe((res: any) => {
      if (res.pending_homeworks?.length > 0) {
        res.pending_homeworks.forEach((ph: any) => {
          ph.homeworks.forEach((h: any) => {
            this.homework_pending.push({
              ...h,
              _id: ph._id,
              classid: ph.classid
            })
          })
        });
      }
    })
  }

  getUserAttendence() {
    this.memberApi.getClassList(this.userid).subscribe((res: any) => {
      const classes = res?.map((r: any) => r.groupid) || [];
      this.classes = res
      this.memberApi.getAttendenceForUserClasses(this.id, this.userid, classes.join(",")).subscribe(res => {
        this.attendenceDetails = res;
        // console.log(this.attendenceDetails)
        if (this.classes !== null) {
          if (this.classes.length > 0) {
            this.class_name = this.classes[0].group_info.basic_information.name.first_name || 'select a class'
            this.setCurrentClass(this.classes[0])
          }
        }
      })
    })
    // for (let index = 0; index < classes.length; index++) {
    //   const element = classes[index];
    //   this.reportsapiServiceService.getOverAllList(element, this.userid).subscribe((res: any) => {
    //     if (res?.pd_info?.data) {
    //       this.OverSession = this.OverSession.concat([...res?.pd_info?.data])
    //       this.OverSessionAll = this.OverSessionAll.concat([...res?.pd_info?.data])
    //     }
    //     this.printPdInfoEndTimes()
    //   })
    // }
  }

  setCurrentClass(element: any) {
    this.class_name = element.group_info.basic_information.name.first_name
    this.reportsapiService.getOverAllList(element.groupid, this.userid).subscribe((res: any) => {
      if (res?.pd_info?.data) {
        this.OverSession = this.OverSession.concat([...res?.pd_info?.data])
        this.OverSessionAll = this.OverSessionAll.concat([...res?.pd_info?.data])
        this.overall_info = res?.pd_info
      }
      this.printPdInfoEndTimes()
    })
  }

  getAcademicStats() {
    this.academicStats = null;
    this.selectedTerm = "";
    this.academicStatsLoading = true;
    this.memberApi.getProfileAcademicStats(this.id, this.userid, { year: new Date(this.selectedYear).getFullYear() }).subscribe({
      next:(res: any)=>{
        if (res?.data?.length > 0) {
          this.academicStats = res.data[0];
          this.selectedTerm = this.academicStats?.academics?.course?.term?.[0]?.name || '';
          const subjects = this.academicStats?.academics?.course?.subjects || [];
          const scoring = this.academicStats?.academics?.course?.scoring;
          const grades = scoring?.grades || [];
          if (scoring.scoring_scheme === 'alphabetic') {
            if (grades && grades.length > 0) {
              const sortedGrades = _.orderBy(grades.map((g: any) => ({ ...g, priority: parseInt(g.priority) })), ['priority'], ['asc']);
              this.academicStats.academics.course.scoring.grades = sortedGrades.map((s, i) => {
                return {
                  ...s,
                  grade_offset: (() => {
                    if (i === 0) {
                      return 100;
                    } else if (i === (sortedGrades.length - 1)) {
                      return 0;
                    }
                    return Math.ceil((100 / (sortedGrades.length - 1)) * ((sortedGrades.length - 1) - i));
                  })()
                }
              });
            }
          } else if (scoring?.scoring_scheme === 'numerical') {
            this.academicStats.academics.course.scoring.grades = [
              {
                grade: scoring.max_score,
                grade_offset: 100,
                priority: 1
              },
              {
                grade: 0,
                grade_offset: 0,
                priority: 2
              }
            ]
          }
          if (subjects && subjects.length > 0) {
            const sortedGrades = this.academicStats?.academics?.course?.scoring.grades || [];
            this.academicStats.academics.course.subjects = subjects.map((s: any) => {
              const targetDetails = s.target_details?.[0] || {};
              return {
                ...s,
                target_details: {
                  ...targetDetails,
                  current_grade_offset: (() => {
                    if (scoring?.scoring_scheme === 'alphabetic') {
                      return (sortedGrades.find((f: any) => targetDetails.current_score === f.grade)?.grade_offset) || 0
                    } else if (scoring?.scoring_scheme === 'numerical') {
                      return Math.ceil((parseInt(targetDetails.current_score) / parseInt(scoring.max_score)) * 100)
                    }
                  })(),
                  target_grade_offset: (() => {
                    if (scoring?.scoring_scheme === 'alphabetic') {
                      return (sortedGrades.find((f: any) => s.target_grade === f.grade)?.grade_offset) || 0
                    } else if (scoring?.scoring_scheme === 'numerical') {
                      return Math.ceil((parseInt(s.target_grade) / parseInt(scoring.max_score)) * 100)
                    }
                  })()
                }
              }
            })
          }
        }
        this.updateTerm();
        this.academicStatsLoading = false;
      },
      error:()=>{
        this.academicStatsLoading = false;
      }
    })
  }

  updateTerm() {
    const subjectsInCurrentTerm = (this.academicStats?.academics?.course?.subjects || []).filter((f: any) =>
      f.target_details.term === this.selectedTerm
    )
    this.targetAchievedCountForGrades = subjectsInCurrentTerm.filter((f: any) => {
      return f.target_details.current_grade_offset >= f.target_details.target_grade_offset
    }).length;
    this.totalSubjectsCount = subjectsInCurrentTerm.length;
  }

  filterGallery(filter: any) {
    this.user_feed = this.user_feed_all.filter((item: any) => {
      return item.uploads[0].type.toLowerCase().includes(filter.toLowerCase());
    });
  }

  isPresent(attendance: any) {
    if (attendance == null || attendance.length == 0 || attendance == undefined) {
      return false
    } else {
      return attendance.includes(this.id)
    }
  }


  calcPercentage(current: any, total: any) {
    if (!current || !total) {
      return 0;
    }
    return Math.floor((parseInt(current) / parseInt(total)) * 100)
  }

  calcPercentageAnti(current: any, total: any) {
    return 100 - ((current / total) * 100)
  }

  /**
   * Calculate the duration with two times.
   *
   * @param time1 time one.
   * @param time2 tine two.
   * @returns duration in minutes.
   */
  calcDuration(time1: any, time2: any) {
    const date1 = new Date(time1);
    const date2 = new Date(time2);
    const difference = date2.getTime() - date1.getTime();
    const resultInMinutes = Math.round(difference / 60000);
    // console.log(time1, time2)
    return (resultInMinutes == 0 ? 0 : resultInMinutes) + " minutes"

  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  selectedYearHandler(ev: any, input: any) {
    const { _d } = ev;
    _d.setMonth(11);
    _d.setDate(31);
    this.selectedYear = _d;
    this.getAcademicStats();
    this.picker.close()
  }
}
